import {
  axiosWithToken as _axiosWithToken,
  axiosWithFile as _axiosWithFile,
} from './axios'

export const axiosWithToken = _axiosWithToken
export const axiosWithFile = _axiosWithFile
